import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ModalStyled, useShowHolidayModal } from 'src/components';
import SacPlusIcon from 'src/images/icons/sac-plus-fire-cart.svg?react';

export const HolidayModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  useShowHolidayModal({ setIsOpen });

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <ModalStyled open={isOpen} onClose={handleClose}>
      <div className='flex flex-col items-center justify-center gap-4 p-4 sm:py-6 md:gap-6 md:px-6 md:py-8'>
        <div className='flex flex-col items-center justify-center gap-2 md:gap-3'>
          <SacPlusIcon
            title='Full cart with fire emoji'
            className='h-auto w-[125px]'
          />

          <h3 className='heading-300 text-balance text-center'>
            {t('history.holiday.title')}
          </h3>
          <p className='text-200 text-center xs:px-2 sm:px-4'>
            <Trans
              i18nKey={t('history.holiday.body')}
              components={[
                // eslint-disable-next-line
                <a
                  href={`/plus`}
                  className='underline transition-all hover:opacity-70'
                />,
                <strong />,
              ]}
            />
          </p>
        </div>

        <div className='flex w-full flex-col items-center justify-center gap-2 sm:flex-row-reverse'>
          <Link
            to='/plus/upgrade?promo=THANKS2025'
            className='button-primary h-12 w-full sm:w-[70%]'
          >
            {t('history.beta_end.button_primary')}
          </Link>
          <button
            onClick={handleClose}
            className='button-secondary h-12 w-full sm:w-[30%]'
          >
            {t('history.beta_end.button_secondary')}
          </button>
        </div>
      </div>
    </ModalStyled>
  );
};
